import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@crisp/crisp-ui/cabbage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSliders } from '@crisp/crisp-ui/icons/classic/regular';

export interface ExpandableProps {
  title?: string;
  defaultOpen?: boolean | string;
  children?: React.ReactNode;
  className?: string;
}

export const Expandable: React.FC<ExpandableProps> = ({
  title = 'Details',
  defaultOpen = false,
  children,
  className = '',
}) => {
  const open = defaultOpen === true || defaultOpen === 'true';

  return (
    <Accordion className={className} defaultValue={open ? ['details'] : []}>
      <AccordionItem value="details">
        <AccordionTrigger>
          <FontAwesomeIcon icon={faSliders} />
          {title}
        </AccordionTrigger>
        <AccordionContent>{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default Expandable;
